import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-g-captcha',
  templateUrl: './g-captcha.component.html',
  styleUrls: ['./g-captcha.component.scss']
})
export class GCaptchaComponent implements OnInit {

  @Output() dataEmit = new EventEmitter();

  captchaSiteKey = environment.invisible_captcha;
  captchaResponse;
  captchaPopup;
  stopLoop;
  loopCount = 0;

  @ViewChild(RecaptchaComponent, { static: true }) captchaRef: RecaptchaComponent;

  constructor() { }

  ngOnInit(): void {
  }

  executeCaptcha() {
    this.captchaPopup = document.querySelector('iframe[src^="https://www.google.com/recaptcha"][src*="bframe"]');
    if (this.captchaPopup) {
      this.initCaptchaListner();
      this.captchaRef.execute();
    } else {
      setTimeout(() => this.executeCaptcha(), 2000);
    }
  }

  captchaResolved(response) {
    if (response) {
      this.captchaResponse = response;
      this.dataEmit.emit(response);
      this.resetCaptcha();
      document.body.classList.toggle('noscroll', false);
    }
  }

  initCaptchaListner() {
    const recaptchaWindow: any = this.captchaPopup.parentNode.parentNode;
    this.checkForChallengePopup();
    new MutationObserver(() => {
      this.checkForChallengePopup();
      if (recaptchaWindow.style.opacity === 0) {
        this.onCloseCaptcha();
      }
    }).observe(recaptchaWindow, { attributes: true, attributeFilter: ['style'] });
  }

  captchaError() {
    this.resetCaptcha();
  }

  onCloseCaptcha() {
    if (this.captchaPopup && !this.captchaResponse) {
      this.captchaRef.reset();
      this.captchaPopup = null;
    }
  }

  resetCaptcha() {
    if (this.captchaResponse) {
      this.captchaRef.reset();
      this.stopLoop = true;
    }
    this.captchaResponse = null;
  }

  checkForChallengePopup() {
    const captcha: any = document.querySelector('iframe[src^="https://www.google.com/recaptcha"][src*="bframe"]')?.parentNode?.parentNode;
    if (!captcha) { return; }
    captcha.style['z-index'] = 1001;
    if (!+captcha.style.opacity) {
      document.body.classList.toggle('noscroll', false);
      this.loopCount++;
    } else {
      document.body.classList.toggle('noscroll', true);
      captcha.style.position = 'fixed';
      captcha.style.top = '50px';
    }
    if (!this.stopLoop && this.loopCount < 6) {
      setTimeout(() => {
        this.checkForChallengePopup();
      }, 300);
    } else {
      this.loopCount = 0;
    }
  }

}
